// Copyright (c) 2023 Deere & Company

import actions from '../../actions-list';

export const updateDuplicatePinPlateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILTER_BY
});

export const updateDuplicatePinPlateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_BY
});

export const updateDuplicatePinPlateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/duplicate-pin-plate-search-filters.js